import { createSlice } from '@reduxjs/toolkit'
import { ChainType } from '../../constants/chains'

export interface ConnectState {
  // 0: Evm, 1: Starknet, undefined: Unknown
  chainType: ChainType | undefined
}
const initialState: ConnectState = {
  chainType: undefined,
}
export const connectSlice = createSlice({
  name: 'connect',
  initialState,
  reducers: {
    updateChainType(state, { payload }) {
      state.chainType = payload.chainType
    },
  },
})

export const { updateChainType } = connectSlice.actions
